import React from 'react';
import { Avatar, ListItemAvatar } from '@mui/material';
import { useTheme } from '@mui/system';
import { lighten } from '@mui/material/styles';

interface ItemAvatarProps {
  icon: React.ElementType;
  compact?: boolean;
}

function ItemAvatar({ icon: Icon, compact }: ItemAvatarProps) {
  const theme = useTheme();
  const size = compact ? 40 : 48;

  return (
    <ListItemAvatar>
      <Avatar
        sx={{
          bgcolor: lighten(theme.palette.secondary.main, 0.8),
          width: size,
          height: size,
        }}
      >
        <Icon color="secondary" />
      </Avatar>
    </ListItemAvatar>
  );
}

export default ItemAvatar;
